export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      options: [],
    };
  },
  computed: {
    labelID() {
      return `listbox-${this.label.toLowerCase().split(' ').join('-')}`;
    },
  },
  methods: {
    open() {
      if (this.isOpen) {
        return;
      }
      this.isOpen = true;
    },
    close() {
      if (!this.isOpen) {
        return;
      }
      this.isOpen = false;
    },
    handleSelect(item) {
      this.$emit('input', item);
      this.close();
    },
  },

};
